import sliceCreator from '../../index.jsx';
import {UPDATE_DAILY_PUNCH } from '../../../constants/index.jsx';
const _updateDailyPunchAction = sliceCreator('UPDATE_DAILY_PUNCH', UPDATE_DAILY_PUNCH, 'put');

const { asyncAction: updateDailyPunchAction, reducer, clearData: clearUpdateDailyPunchAction } = _updateDailyPunchAction;

export default reducer;

export {
    updateDailyPunchAction,
    clearUpdateDailyPunchAction
}